import { UserRole } from "@storyline/shared";
import { useEffect } from "react";
import { getMe } from "@/src/auth/services/auth-http.service";
import { denyAccess, getIsHydrating, setHydrating, signIn, signOut } from "@/src/common/redux/session-slice";
import { useAppDispatch, useAppSelector } from "@/src/common/redux/store";
import { clearTokens, getAccessToken } from "@/src/common/services/token-store.service";

export const useSessionBootstrap = () => {
	const dispatch = useAppDispatch();
	const isHydrating = useAppSelector(getIsHydrating);

	useEffect(() => {
		let active = true;
		const run = async () => {
			dispatch(setHydrating(true));
			try {
				const token = await getAccessToken();
				if (!token) {
					dispatch(signOut());
					return;
				}
				const user = await getMe();
				if (!active) {
					return;
				}
				if (user.role === UserRole.ADMIN) {
					dispatch(signIn(user));
				} else {
					await clearTokens();
					dispatch(denyAccess());
				}
			} catch {
				if (active) {
					await clearTokens();
					dispatch(signOut());
				}
			} finally {
				if (active) {
					dispatch(setHydrating(false));
				}
			}
		};
		void run();
		return () => {
			active = false;
		};
	}, [dispatch]);

	return { isHydrating };
};
